<!-- 捐赠成功页面
捐赠收据页面点击完成跳转至该页面-->
<template>
  <!-- <div class="indexBox"> -->
    <div class="donationSuccDiv">
      <div class="succImageDiv">
        <img
          src="../../assets/image/btn_chenggong_nor.png"
          alt="成功"
          class="succImage"
        />
      </div>
      <div class="succTitle">捐赠成功</div>
      <div class="succWords">感谢您对母校的捐赠！</div>
      <div class="certificate" @click="gotoCertificate">查看证书</div>
      <!-- <div class="alumnusDisplayDiv">
      <div class="alumnusDiv">
        <div class="alumnus clearfix" v-for="item in alumnus" :key="item.aUserId">
          <div class="photoDiv">
            <img :src="item.aUrl" alt="校友照片" class="photo" />
            <div class="sexImgDiv">
              <img
                src="../../assets/image/btn_nan_nor.png"
                v-if="item.asex == 1"
                alt="男"
                class="sexImg"
              />
              <img
                src="../../assets/image/btn_nv_nor.png"
                v-else
                alt="女"
                class="sexImg"
              />
            </div>
          </div>
          <div class="adress" v-if="item.aCity == myCity">本地</div>
          <div class="adress" v-else>{{ item.aCity }}</div>
          <div class="nameAndGraduates clearfix">
            <div class="name">{{ item.aName }}</div>
            <div class="graduates">{{ item.aXuejie }}</div>
          </div>
          <div class="resources">资源：{{ item.aIndustry }}</div>
        </div>
      </div>
    </div> -->
      <div class="btnDiv">
        <button class="btn" @click="gotoAlumniResources">
          查看更多捐赠项目
        </button>
      </div>
    </div>
  <!-- </div> -->
</template>
<script>
import Base64 from "@/utils/base64";
export default {
  data() {
    return {
      alumnus: "",
      donateId: window.localStorage.getItem("donateId"),
      myCity: "",
      // userId:window.localStorage.getItem('user_id'),
      // userId:'43995382',
    };
  },
  created() {
    this.getAlumnus();
    this.getMyCity();
  },
  methods: {
    async getAlumnus() {
      const result = await this.$http.get(
        "/amresources/getAlumniInDetailList",
        {
          params: {
            city: "",
            industry: "",
            name: "",
            sex: "",
            college: "",
            major: "",
            xuejie: "",
            xueli: "",
            danwei: "",
            hangye: "",
            hobby: "",
            userId: this.userId,
            currentPage: 1,
            perPage: 4,
            bigShot: 0,
          },
        }
      );
      this.alumnus = result.data.list;
    },
    gotoAlumniResources() {
      // return this.$router.push("/alumniResourcesNew");
      return this.$router.push("/donationList");
    },
    gotoCertificate() {
      return this.$router.push({
        path: "/certificate",
        query: { donateId: window.localStorage.getItem("donateId") },
      });
    },
    async getMyCity() {
      let base64 = new Base64()
      const result = await this.$http.get("/my/getBasic", {
        params: { userId: base64.encode(window.localStorage.getItem("user_id"))},
      });
      this.myCity = result.data.city;
    },
  },
};
</script>
<style lang="less" scoped>
.indexBox {
  position: relative;
}
.donationSuccDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;;
  margin-top: 0px;
  background-image: url("~@/assets/image/btn_renzhengchenggong_nor.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .succImageDiv {
    margin-top: 50px;
    width: 20%;
    .succImage {
      width: 100%;
    }
  }
  .succTitle {
    margin-top: 20px;
    font-size: 1.5rem;
    font-weight: bold;
    color: #333333;
  }
  .succWords {
    margin-top: 20px;
    font-size: 1.3rem;
    font-weight: bold;
    color: #333333;
  }
  .certificate {
    margin-top: 20px;
    color: #00706e;
  }
  .alumnusDisplayDiv {
    position: relative;
    .alumnusDiv {
      position: relative;
      .alumnus {
        position: relative;
        float: left;
        width: 44%;
        background: #ffffff;
        border: 1px solid #e1e1e1;
        border-radius: 15px;
        margin: 5% 2.5% 0 2.5%;
        .photoDiv {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 20px;
          width: 33%;
          height: 15.8vw;
          .photo {
            width: 100%;
            height: 100%;
            border-radius: 999px;
          }
          .sexImgDiv {
            position: absolute;
            left: 100%;
            top: 0%;
            transform: translateX(-50%);
            width: 20px;
            .sexImg {
              width: 100%;
            }
          }
        }
        .adress {
          text-align: center;
          margin-top: 10px;
          font-weight: bold;
          color: #00706e;
        }
        .nameAndGraduates {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          width: 56%;
          margin-top: 5px;
          .name {
            float: left;
            font-size: 1.1rem;
            font-weight: bold;
            color: #333333;
          }
          .graduates {
            float: right;
            font-weight: 400;
            color: #666666;
          }
        }
        .resources {
          position: relative;
          left: 5%;
          width: 90%;
          margin: 5px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}
.btnDiv {
  margin-top: 30px;
  width: 90%;
  .btn {
    width: 100%;
    background: linear-gradient(270deg, #00706e, #00706e);
    border-radius: 45px;
    border: 0;
    font-size: 1.1rem;
    font-weight: bold;
    color: #ffffff;
    padding: 10px 0;
  }
}
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/donation/DonationSucc.vue